// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gl-0";
export var headerCellHover = "_gl-1";
export var readCellContainer = "_gl-2";
export var unreadIndicator = "_gl-3";